var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"df-page df-page-store-change"},[_c('df-header-mobile'),_c('section',{staticClass:"df-page-body"},[_c('df-store-card',{attrs:{"store":_vm.currentStore},on:{"storeCardClick":_vm.goToStorePage}}),_c('df-store-selection')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }